import React from 'react';
import HeroSection from '../components/HeroSection';
import PawStories from '../components/PawStories';
import MeetTheFounders from '../components/MeetTheFounders';
import HappeningThisWeek from '../components/HappeningThisWeek';

const Events = () => {
  return (
    <div className="bg-gray-50 min-h-screen">
      {/* Main Content */}
      <div className="bg-[#f8f8f8]">
        {/* In the Spotlight Section */}
        <HeroSection mode="events" />
        <HappeningThisWeek />

        {/* Paw Stories Section */}
       
          <PawStories />
        

        {/* Meet the Founders Section */}
        <div className="bg-[#f8f8f8]">
          <MeetTheFounders />
        </div>
      </div>
    </div>
  );
};

export default Events; 